import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { SYS_ADMIN } from 'config/permissions/roles';
import riskByYear from './risk-by-year.component';
import riskByYearService from './risk-by-year.service';

export default
  angular.module('components.reports.riskByYear', [
    uiRouter
  ])
    .component('riskByYear', riskByYear)
    .service('RiskByYearService', riskByYearService)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('riskByYear', {
          parent: 'reports',
          url: '/risk-by-year',
          component: 'riskByYear',
          data: {
            permissions: {
              only: [SYS_ADMIN],
              redirectTo: 'dashboard'
            }
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/reports/risk-by-year/risk-by-year.module.js